import CloseIcon from '@mui/icons-material/Close';
import {
  DialogTitle,
  Typography,
  IconButton,
  DialogContent,
  Box,
  Grid,
  TextField,
  DialogActions,
} from '@mui/material';
import { IPrompt } from 'wisestep-api';
import { WsDialog, WsDialogSize, WsButton } from 'wisestep-base';

import { warning } from '../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../utils/NotificationStore';
import { generateNewPromptItem } from '../utils/PromptHelper';

export interface IPromptDialog {
  openPromptDialog: boolean;
  promptData: IPrompt[];
  newPromptTitle: string;
  newPromptDescription: string;
  onNewPromptTitle: (value: string) => void;
  handleOpenPromptDialog: (value: boolean) => void;
  onNewPromptDescription: (value: string) => void;
  onSetPromptdata: (value: IPrompt[]) => void;
}

const PromptDialogForAdd = ({
  openPromptDialog,
  newPromptTitle,
  newPromptDescription,
  onNewPromptTitle,
  handleOpenPromptDialog,
  onNewPromptDescription,
  onSetPromptdata,
  promptData,
}: IPromptDialog) => {
  const handleInputChangeOnAddPromptTitle = (event) => onNewPromptTitle(event.target.value);
  const handleInputChangeOnAddPrompt = (event) => onNewPromptDescription(event.target.value);
  const setNotification = useNotificationStore((state) => state.setNotification);

  const onContinue = () => {
    if (newPromptTitle.trim().length == 0) {
      setNotification(warning('Please fill the prompt title'));
    } else if (newPromptDescription.trim().length == 0) {
      setNotification(warning('Please fill the prompt'));
    } else {
      onSetPromptdata([
        ...promptData,
        generateNewPromptItem(newPromptTitle, newPromptDescription, promptData[0]),
      ]);
      closeDialog();
    }
  };
  const closeDialog = () => {
    handleOpenPromptDialog(false);
    onNewPromptTitle('');
    onNewPromptDescription('');
  };

  return (
    <WsDialog openDialog={openPromptDialog} size={WsDialogSize.MEDIUM}>
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography variant="h6">
          Add Prompt
          <span style={{ color: 'rgba(0, 0, 0, 0.54)' }}> - {promptData[0].scope} </span>
        </Typography>
        <Typography variant="h6">
          <IconButton
            onClick={closeDialog}
            size="small"
            sx={{
              backgroundColor: 'transparent',
              '&:hover': {
                backgroundColor: 'transparent',
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </Typography>
      </DialogTitle>
      <DialogContent
        sx={{
          backgroundColor: '#EAEAF1',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Box>
          <Grid
            container
            spacing={1}
            sx={{
              backgroundColor: 'white',
              display: 'flex',
              alignItems: 'center',
              marginTop: 2.5,
            }}
          >
            <Grid item xs={12} sx={{ marginLeft: 2.5 }}>
              <Typography variant="h6" align="left">
                Prompt Title *
              </Typography>
            </Grid>
            <Grid item xs={12} sx={{ marginLeft: 2.5 }}>
              <TextField
                required={true}
                size="small"
                sx={{
                  width: '80%',
                }}
                value={newPromptTitle}
                placeholder="Enter title"
                onChange={handleInputChangeOnAddPromptTitle}
              />
            </Grid>
            <Grid item xs={12} sx={{ marginLeft: 2.5 }}>
              <Typography variant="h6" align="left">
                Prompt *
              </Typography>
            </Grid>
            <Grid item xs={12} sx={{ marginLeft: 2.5 }}>
              <TextField
                size="small"
                sx={{
                  width: '95%',
                  marginRight: 1.2,
                  marginBottom: 2.5,
                }}
                required={true}
                value={newPromptDescription}
                placeholder="Write prompt to ChatGPT"
                onChange={handleInputChangeOnAddPrompt}
                multiline
                rows={6}
              />
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions
        sx={{
          alignItems: 'center',
        }}
      >
        <Box sx={{ marginRight: 2 }}>
          <WsButton size="large" variant="contained" onClick={onContinue}>
            Save
          </WsButton>
        </Box>
      </DialogActions>
    </WsDialog>
  );
};
export default PromptDialogForAdd;
